import _toConsumableArray from "/home/maxwell/maxwell-sms-shopify-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/maxwell/maxwell-sms-shopify-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useCallback } from 'react';
import { isSection } from '../../utilities/options.js';
import { arraysAreEqual } from '../../utilities/arrays.js';
import { useDeepEffect } from '../../utilities/use-deep-effect.js';
import styles from './OptionList.scss.js';
import { Option } from './components/Option/Option.js';
import { useUniqueId } from '../../utilities/unique-id/hooks.js';

function OptionList(_ref) {
  var options = _ref.options,
      sections = _ref.sections,
      title = _ref.title,
      selected = _ref.selected,
      allowMultiple = _ref.allowMultiple,
      role = _ref.role,
      optionRole = _ref.optionRole,
      onChange = _ref.onChange,
      idProp = _ref.id;

  var _useState = useState(createNormalizedOptions(options, sections, title)),
      _useState2 = _slicedToArray(_useState, 2),
      normalizedOptions = _useState2[0],
      setNormalizedOptions = _useState2[1];

  var id = useUniqueId('OptionList', idProp);
  useDeepEffect(function () {
    setNormalizedOptions(createNormalizedOptions(options || [], sections || [], title));
  }, [options, sections, title], optionArraysAreEqual);
  var handleClick = useCallback(function (sectionIndex, optionIndex) {
    var selectedValue = normalizedOptions[sectionIndex].options[optionIndex].value;
    var foundIndex = selected.indexOf(selectedValue);

    if (allowMultiple) {
      var newSelection = foundIndex === -1 ? [selectedValue].concat(_toConsumableArray(selected)) : [].concat(_toConsumableArray(selected.slice(0, foundIndex)), _toConsumableArray(selected.slice(foundIndex + 1, selected.length)));
      onChange(newSelection);
      return;
    }

    onChange([selectedValue]);
  }, [normalizedOptions, selected, allowMultiple, onChange]);
  var optionsExist = normalizedOptions.length > 0;
  var optionsMarkup = optionsExist ? normalizedOptions.map(function (_ref2, sectionIndex) {
    var title = _ref2.title,
        options = _ref2.options;
    var titleMarkup = title ?
    /*#__PURE__*/
    React.createElement("p", {
      className: styles.Title
    }, title) : null;
    var optionsMarkup = options && options.map(function (option, optionIndex) {
      var isSelected = selected.includes(option.value);
      var optionId = option.id || "".concat(id, "-").concat(sectionIndex, "-").concat(optionIndex);
      return (
        /*#__PURE__*/
        React.createElement(Option, Object.assign({}, option, {
          key: optionId,
          id: optionId,
          section: sectionIndex,
          index: optionIndex,
          onClick: handleClick,
          select: isSelected,
          allowMultiple: allowMultiple,
          role: optionRole
        }))
      );
    });
    return (
      /*#__PURE__*/
      React.createElement("li", {
        key: title || "noTitle-".concat(sectionIndex)
      }, titleMarkup,
      /*#__PURE__*/
      React.createElement("ul", {
        className: styles.Options,
        id: "".concat(id, "-").concat(sectionIndex),
        role: role
      }, optionsMarkup))
    );
  }) : null;
  return (
    /*#__PURE__*/
    React.createElement("ul", {
      className: styles.OptionList,
      role: role
    }, optionsMarkup)
  );
}

function createNormalizedOptions(options, sections, title) {
  if (options == null) {
    var section = {
      options: [],
      title: title
    };
    return sections == null ? [] : [section].concat(_toConsumableArray(sections));
  }

  if (sections == null) {
    return [{
      title: title,
      options: options
    }];
  }

  return [{
    title: title,
    options: options
  }].concat(_toConsumableArray(sections));
}

function optionArraysAreEqual(firstArray, secondArray) {
  if (isSection(firstArray) && isSection(secondArray)) {
    return arraysAreEqual(firstArray, secondArray, testSectionsPropEquality);
  }

  return arraysAreEqual(firstArray, secondArray);
}

function testSectionsPropEquality(previousSection, currentSection) {
  var previousOptions = previousSection.options;
  var currentOptions = currentSection.options;
  var optionsAreEqual = arraysAreEqual(previousOptions, currentOptions);
  var titlesAreEqual = previousSection.title === currentSection.title;
  return optionsAreEqual && titlesAreEqual;
}

export { OptionList };